import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
import { PlusIcon, MinusIcon } from '../lib/icons';
const FAQS = [{
  q: '¿Sirve si nunca hice nada de bienestar holístico antes?',
  a: 'Sí. El Tomo 1 está diseñado para empezar desde cero absoluto. No necesitás experiencia previa de ningún tipo. El método te lleva de la mano desde el primer concepto hasta la implementación completa.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital en formato PDF. Acceso inmediato después del pago. Te llega por email con el link de descarga en menos de 5 minutos. Podés leerlo en celular, tablet o computadora. Podés imprimirlo si preferís trabajar en papel.'
}, {
  q: '¿Necesito materiales especiales para hacer las prácticas?',
  a: 'No. La mayoría de las prácticas requieren solo un espacio tranquilo, un diario y lapicera. Algunas prácticas opcionales como aromaterapia o cristales tienen alternativas simples que podés conseguir en cualquier herboristería argentina.'
}, {
  q: '¿Cuánto tiempo por día requiere el método?',
  a: 'El programa mínimo requiere 40 minutos diarios. El completo, 60 a 90 minutos. Diseñamos el método en 3 niveles para que se adapte a cualquier realidad cotidiana.'
}, {
  q: '¿Cuánto tiempo tengo acceso al material?',
  a: 'Acceso de por vida. Una sola compra, para siempre. Sin mensualidades ni renovaciones de ningún tipo.'
}, {
  q: '¿Tiene garantía real?',
  a: '7 días de garantía total sin preguntas. Si no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios. Sin burocracia. Sin drama.'
}, {
  q: '¿Es solo para mujeres que buscan ser mamás?',
  a: 'No. El MegaPack Código Fértil trabaja la fertilidad en su sentido más amplio: la energía creativa, vital y femenina en todas sus expresiones. Es para cualquier mujer que quiera reconectarse con su bienestar, su cuerpo y su energía femenina.'
}, {
  q: '¿Puedo hacer las prácticas si tengo tratamiento médico?',
  a: 'El método es completamente complementario a cualquier tratamiento médico. Siempre recomendamos consultar con tu médico ante cualquier duda específica de salud.'
}];
function FAQItem({
  q,
  a,
  isOpen,
  onClick
}: {
  q: string;
  a: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="border border-brand-border-soft rounded-xl bg-white overflow-hidden transition-all duration-300 shadow-sm" data-id="element-95">
      <button onClick={onClick} className="w-full flex items-center justify-between p-5 text-left focus:outline-none hover:bg-brand-primary/30 transition-colors" data-id="element-96">
        <span className="text-brand-heading font-bold text-base md:text-lg pr-4" data-id="element-97">
          {q}
        </span>
        <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-brand-cta text-white' : 'bg-brand-primary text-brand-cta'}`} data-id="element-98">
          {isOpen ? <MinusIcon size={18} data-id="element-99" /> : <PlusIcon size={18} data-id="element-100" />}
        </div>
      </button>
      <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-101">
        <div className="p-5 pt-0 text-brand-body text-sm md:text-base leading-relaxed border-t border-brand-border-soft mt-2" data-id="element-102">
          {a}
        </div>
      </div>
    </div>;
}
export function FAQSection() {
  const [ref, vis] = useReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-card py-8 md:py-10 px-5 sm:px-6 border-t border-brand-border-soft" data-id="element-103">
      <div className="container mx-auto max-w-3xl" data-id="element-104">
        <div ref={ref} className={`reveal text-center mb-6 ${vis ? 'is-visible' : ''}`} data-id="element-105">
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-brand-heading tracking-wide" data-id="element-106">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>
        <div className="space-y-4" data-id="element-107">
          {FAQS.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} isOpen={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-108" />)}
        </div>
      </div>
    </section>;
}